// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.container-cadastrar-departamento {
    width: calc(100% - 1.1rem);
    padding-left: 5.1rem;
    padding-top: 3.9rem;
    display: flex;
    flex-direction: column;
    align-items: center;
    height: max-content;
    gap: 1rem;
}

.container-geral-cadastro-departamento {
    box-shadow: 2px 3px 4px 2px rgba(0, 0, 0, .1);
    border-radius: 8px;
}

.formulario-cadastrar-departamento {
    display: flex;
    flex-direction: column;
    width: max-content;
    gap: 1rem;
    background-color: var(--branco-padrao);
    padding: .7rem 1rem;
    border-radius: 0 0 8px 8px;
}

.formulario-cadastrar-departamento form {
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    gap: 1rem;
}

.inputs-principais-cadastro-departamento {
    display: flex;
    flex-direction: column;
    width: max-content;
    gap: 1rem;
    width: 100%;
}

.inputs-principais-cadastro-departamento .nome-departamento {
    min-width: 50%;
}

.botoes-cadastro-departamento {
    margin-top: .5rem;
    display: flex;
    gap: 1rem;
}

.container-input-select-padrao.departamento {
    min-width: 13.5rem;
}

.container-input-select-padrao.tipo-usuario {
    min-width: 13.5rem;
}

.container-input-select-padrao.situacao-cadastro {
    min-width: 13.5rem;
}

.sigla-departamento-cad {
    flex-grow: 1;
}

.nome-departamento-cad {
    flex-grow: 2;
}

.situacao-cadastro-departamento-cad {
    flex-grow: 1;
}`, "",{"version":3,"sources":["webpack://./src/components/FormCadastroDepartamento/FormCadastroDepartamento.css"],"names":[],"mappings":"AAAA;IACI,0BAA0B;IAC1B,oBAAoB;IACpB,mBAAmB;IACnB,aAAa;IACb,sBAAsB;IACtB,mBAAmB;IACnB,mBAAmB;IACnB,SAAS;AACb;;AAEA;IACI,6CAA6C;IAC7C,kBAAkB;AACtB;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,kBAAkB;IAClB,SAAS;IACT,sCAAsC;IACtC,mBAAmB;IACnB,0BAA0B;AAC9B;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,8BAA8B;IAC9B,SAAS;AACb;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,kBAAkB;IAClB,SAAS;IACT,WAAW;AACf;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,iBAAiB;IACjB,aAAa;IACb,SAAS;AACb;;AAEA;IACI,kBAAkB;AACtB;;AAEA;IACI,kBAAkB;AACtB;;AAEA;IACI,kBAAkB;AACtB;;AAEA;IACI,YAAY;AAChB;;AAEA;IACI,YAAY;AAChB;;AAEA;IACI,YAAY;AAChB","sourcesContent":[".container-cadastrar-departamento {\n    width: calc(100% - 1.1rem);\n    padding-left: 5.1rem;\n    padding-top: 3.9rem;\n    display: flex;\n    flex-direction: column;\n    align-items: center;\n    height: max-content;\n    gap: 1rem;\n}\n\n.container-geral-cadastro-departamento {\n    box-shadow: 2px 3px 4px 2px rgba(0, 0, 0, .1);\n    border-radius: 8px;\n}\n\n.formulario-cadastrar-departamento {\n    display: flex;\n    flex-direction: column;\n    width: max-content;\n    gap: 1rem;\n    background-color: var(--branco-padrao);\n    padding: .7rem 1rem;\n    border-radius: 0 0 8px 8px;\n}\n\n.formulario-cadastrar-departamento form {\n    display: flex;\n    flex-direction: column;\n    justify-content: space-between;\n    gap: 1rem;\n}\n\n.inputs-principais-cadastro-departamento {\n    display: flex;\n    flex-direction: column;\n    width: max-content;\n    gap: 1rem;\n    width: 100%;\n}\n\n.inputs-principais-cadastro-departamento .nome-departamento {\n    min-width: 50%;\n}\n\n.botoes-cadastro-departamento {\n    margin-top: .5rem;\n    display: flex;\n    gap: 1rem;\n}\n\n.container-input-select-padrao.departamento {\n    min-width: 13.5rem;\n}\n\n.container-input-select-padrao.tipo-usuario {\n    min-width: 13.5rem;\n}\n\n.container-input-select-padrao.situacao-cadastro {\n    min-width: 13.5rem;\n}\n\n.sigla-departamento-cad {\n    flex-grow: 1;\n}\n\n.nome-departamento-cad {\n    flex-grow: 2;\n}\n\n.situacao-cadastro-departamento-cad {\n    flex-grow: 1;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
